import {
  FILTER_BY_CONTRIBUTIONS,
  FILTER_BY_FOLLOWERS,
  FILTER_BY_REPOS,
  FILTER_BY_GISTS,
  ON_FETCH_REPOSITORIES,
  ON_FETCH_REPOSITORIES_FAILURE,
  ON_FETCH_REPOSITORIES_SUCCESS,
} from '../actions/Home';

export interface IState {
  repos: object[];
  dataTable: any;
  page: number;
  loading: boolean;
}

/** Reducer */
export default function homeReducer(state: any, action: any) {
  switch (action.type) {
    case ON_FETCH_REPOSITORIES:
      return {
        ...state,
        loading: true,
      };
    case ON_FETCH_REPOSITORIES_SUCCESS:
      return {
        ...state,
        repos: [...state.repos, ...action.repos],
        dataTable: {
          ...state.dataTable,
          data: [...state.repos, ...action.repos].map(
            (repo: any, i: number) => {
              return {
                name: repo.name,
                i,
                url: repo.url,
                contributors: repo.contributors,
              };
            }
          ),
        },
        page: state.page + 1,
        loading: false,
      };
    case ON_FETCH_REPOSITORIES_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case FILTER_BY_CONTRIBUTIONS:
      return {
        ...state,
        repos: state.repos
          .sort((a: any, b: any) => {
            return b.contributors.length - a.contributors.length;
          })
          .map((repo: any) => {
            return {
              ...repo,
              contributors: repo.contributors.sort((a: any, b: any) =>
                a.contributions > b.contributions ? -1 : 1
              ),
            };
          }),
        dataTable: {
          ...state.dataTable,
          data: state.dataTable.data
            .sort((a: any, b: any) => {
              return b.contributors.length - a.contributors.length;
            })
            .map((repo: any) => {
              return {
                ...repo,
                contributors: repo.contributors.sort((a: any, b: any) =>
                  a.contributions > b.contributions ? -1 : 1
                ),
              };
            }),
        },
      };

    case FILTER_BY_REPOS:
      return {
        ...state,
        repos: state.repos
          .sort((a: any, b: any) => {
            return b.contributors.length - a.contributors.length;
          })
          .map((repo: any) => {
            return {
              ...repo,
              contributors: repo.contributors.sort((a: any, b: any) =>
                a.repos > b.repos ? -1 : 1
              ),
            };
          }),
        dataTable: {
          ...state.dataTable,
          data: state.dataTable.data
            .sort((a: any, b: any) => {
              return b.contributors.length - a.contributors.length;
            })
            .map((repo: any) => {
              return {
                ...repo,
                contributors: repo.contributors.sort((a: any, b: any) =>
                  a.repos > b.repos ? -1 : 1
                ),
              };
            }),
        },
      };

    case FILTER_BY_FOLLOWERS:
      return {
        ...state,
        repos: state.repos
          .sort((a: any, b: any) => {
            return b.contributors.length - a.contributors.length;
          })
          .map((repo: any) => {
            return {
              ...repo,
              contributors: repo.contributors.sort((a: any, b: any) =>
                a.followers > b.followers ? -1 : 1
              ),
            };
          }),
        dataTable: {
          ...state.dataTable,
          data: state.dataTable.data
            .sort((a: any, b: any) => {
              return b.contributors.length - a.contributors.length;
            })
            .map((repo: any) => {
              return {
                ...repo,
                contributors: repo.contributors.sort((a: any, b: any) =>
                  a.followers > b.followers ? -1 : 1
                ),
              };
            }),
        },
      };

    case FILTER_BY_GISTS:
      return {
        ...state,
        repos: state.repos
          .sort((a: any, b: any) => {
            return b.contributors.length - a.contributors.length;
          })
          .map((repo: any) => {
            return {
              ...repo,
              contributors: repo.contributors.sort((a: any, b: any) =>
                a.gists > b.gists ? -1 : 1
              ),
            };
          }),
        dataTable: {
          ...state.dataTable,
          data: state.dataTable.data
            .sort((a: any, b: any) => {
              return b.contributors.length - a.contributors.length;
            })
            .map((repo: any) => {
              return {
                ...repo,
                contributors: repo.contributors.sort((a: any, b: any) =>
                  a.gists > b.gists ? -1 : 1
                ),
              };
            }),
        },
      };
    default:
      return state;
  }
}
